import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

export default function useTestId() {
    const location = useLocation(); // refetch navigation on location change

    const { testId: testIdInParams } = useParams();

    const testId = useMemo(() => testIdInParams, [location]);
    return testId;
}
